/**
 * snackbar
 */

const freelySnackbar = {
  namespaced: true,
  state: {
    enable: false,
    title: null,
    subTitle: null,
    enableCopy: false,
    messages: [],
    color: 'info',
    timeout: 4000,
  },
  getters: {},
  actions: {
    showInfo ({ commit }, { title = null, subTitle = null, messages = [], enableCopy = false, timeout = 4000 }) {
      commit('showInfo', { title:title, subTitle:subTitle, messages:messages, enableCopy:enableCopy, timeout:timeout })
    },
    hide ({ commit }) {
      commit('hide')
    },
  },
  mutations: {
    /**
     * 正常の背景色で通知を表示する.
     * @param state
     * @param title { string | null } タイトル
     * @param subTitle { string | null } サブタイトル
     * @param messages { Array } メッセージ
     * @param enableCopy { boolean } メッセージコピーボタンの表示制御
     * @param timeout { number } タイムアウト
     */
    showInfo (state, { title = null, subTitle = null, messages = [], enableCopy = false, timeout = 4000 }) {
      state.enable = false
      state.title = title;
      state.subTitle = subTitle;
      state.messages = messages
      state.enableCopy = enableCopy;
      state.timeout = timeout;
      state.color = 'info'
      setTimeout(() => {
        state.enable = true
      }, 200)
    },
    hide (state) {
      // state.messages = null
      // state.title = null;
      // state.subTitle = null;
      // state.messages = []
      // state.enableCopy = false;
      // state.timeout = 4000;
      // state.color = 'info'
      state.enable = false
    }
  },
}

export default freelySnackbar
